module.exports = __webpack_public_path__ + "static/media/settingsbg.9101212e.png";